import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input, Typography, Button, Space, Tooltip } from 'antd';
import { WhatsAppOutlined, RedoOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { commonSearch } from 'store/commonSlice';
import { Box } from 'atoms';
import WhatsAppQRCode from './WhatsAppQRCode';

const { Text } = Typography;

export default function ConnectionStatus({
	connectionStatus,
	setConnectionStatus,
	updateGroupList,
}) {
	const [qrVisible, setQrVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [forceRefresh, setForceRefresh] = useState(true);
	const dispatch = useDispatch();
	const refreshStatus = useCallback(() => {
		setIsLoading(true);
		dispatch(commonSearch({ search_type: 'whatsapp_status' }))
			.then((res) => {
				console.log(res);
				setConnectionStatus(res?.rows.status || 'disconnected');
				setIsLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setIsLoading(false);
			});
	}, []);

	useEffect(() => {
		if (forceRefresh) {
			refreshStatus();
			setForceRefresh(false);
		}
	}, [refreshStatus, forceRefresh]);

	const handleShowQR = () => setQrVisible(true);
	const handleRefresh = () => setForceRefresh(true);

	const applySearch = (searchString) => {
		updateGroupList(searchString);
	};

	return (
		<>
			<Box display="flex" justifyContent="space-between" alignItems="center">
				<Box width={300}>
					<Input.Search
						placeholder="Search WhatsApp Group"
						allowClear
						onSearch={applySearch}
					/>
				</Box>
				<Space size="large">
					<Box display="flex" alignItems="center" padding={2} border="1px solid #ddd">
						<Space>
							<Text strong>
								Connection Status:
								<Text
									style={{
										color: connectionStatus === 'connected' ? 'green' : 'red',
										marginLeft: 4,
									}}
								>
									{isLoading ? 'loading...' : connectionStatus}
								</Text>
							</Text>
							<Tooltip title="Refresh Status" mouseEnterDelay={2}>
								<Button icon={<RedoOutlined />} onClick={handleRefresh} />
							</Tooltip>
						</Space>
					</Box>

					<Button
						icon={<WhatsAppOutlined />}
						type="primary"
						onClick={handleShowQR}
						disabled={!connectionStatus || connectionStatus === 'connected'}
					>
						Scan QR
					</Button>
				</Space>
			</Box>
			{qrVisible && (
				<WhatsAppQRCode
					qrVisible={qrVisible}
					setQrVisible={setQrVisible}
					setStatus={setConnectionStatus}
					forceRefresh={setForceRefresh}
				/>
			)}
		</>
	);
}

ConnectionStatus.propTypes = {
	connectionStatus: PropTypes.string,
	setConnectionStatus: PropTypes.func,
	updateGroupList: PropTypes.func,
};
